import React from 'react';
import PropTypes from 'prop-types';
import { Transition as ReactTransition } from 'react-transition-group';
import Velocity from 'velocity-animate';

import I18n from '@module/i18n';
import SplashpageHelper from '@app/helper/splashpage';

import Icon from '@component/icon';

import { WHITE, DARK_BLUE } from '@constant/colors';

export class Doublebox extends React.Component {
  handleEscape = (event) => {
    if (event.key !== 'Escape') {
      return;
    }

    SplashpageHelper.trackFreeFunnel();

    this.props.onEscape();
  };

  // Fade-out and scale up when the component is going away
  onExit(component) {
    Velocity(
      component,
      {
        scale: '1.3',
        opacity: 0,
      },
      { duration: 300 }
    );
  }

  componentDidMount() {
    window.addEventListener('keydown', this.handleEscape);

    SplashpageHelper.trackShow();
  }

  componentWillUnmount() {
    window.removeEventListener('keydown', this.handleEscape);
  }

  handleClick = () => {
    SplashpageHelper.trackFreeFunnel();

    this.props.onClick();
  };

  handleFreeClick = (event) => {
    // Stop Triggering GA tracker in handleClick()
    event.stopPropagation();

    SplashpageHelper.trackFreeFunnel();

    this.props.onFreeClick();
  };

  handlePlusClick = (event) => {
    // Stop Triggering GA tracker in handleClick()
    event.stopPropagation();

    SplashpageHelper.trackPlusFunnel();

    this.props.onPlusClick('Splashpage_Doublebox_blue');
  };

  renderContent() {
    return (
      <div key="splashpage-2017" className="splash-201708">
        <div className="splashpage__background" />

        <div className="content">
          <h1 className="content__heading">
            <span>{SplashpageHelper.content('splash.heading.line_1')}</span>
            <span
              dangerouslySetInnerHTML={{
                __html: SplashpageHelper.content('splash.heading.line_2'),
              }}
            />
          </h1>

          <div className="content__plans">
            <div className="plan plan--free">
              <h2 className="plan__heading">{I18n.t('site.name')}</h2>

              <ul className="plan__features">
                {SplashpageHelper.makeFeatureList('free')}
              </ul>
              <button
                className="button button--free button--transparent"
                onClick={this.handleFreeClick}
              >
                {SplashpageHelper.content('splash.plan.free.cta')}
              </button>
            </div>

            <div className="plan plan--plus">
              <h2 className="plan__heading">
                {I18n.t('site.name')}
                <Icon
                  type="TransferPlus"
                  color={WHITE}
                  backgroundColor={DARK_BLUE}
                />
              </h2>

              <ul className="plan__features">
                {SplashpageHelper.makeFeatureList('plus')}
              </ul>
              <button
                className="button button--plus"
                onClick={this.handlePlusClick}
              >
                {SplashpageHelper.content('splash.plan.plus.cta')}
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }

  // Render our splash page
  render() {
    const classNames = [
      'splashpage',
      'splashpage--doublebox',
      SplashpageHelper.unlimitedContainerClass(),
    ];

    return (
      <ReactTransition
        in={this.props.in}
        timeout={{ in: 0, exit: 300 }}
        unmountOnExit={true}
        onExit={this.onExit}
      >
        <div className={classNames.join(' ')} onClick={this.handleClick}>
          {this.renderContent()}
        </div>
      </ReactTransition>
    );
  }
}

Doublebox.propTypes = {
  in: PropTypes.bool,
  onClick: PropTypes.func.isRequired,
  onFreeClick: PropTypes.func.isRequired,
  onPlusClick: PropTypes.func.isRequired,
  onEscape: PropTypes.func.isRequired,
};

export default Doublebox;
